/*
 * Created Date: 16-01-2024, 9:41:04 am
 * Author: Victor
 * Email: victor@pt-corp.vn
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2024 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

const basePath = '/auth'
export const ROUTER_AUTH = {
	register: `${basePath}/register`,
	login: `${basePath}/login`,
	onboarding: `${basePath}/onboarding`,
	verify_email: `${basePath}/verify/email`,
	forgot_password: `${basePath}/forgot-password`,
	forgot_password_send_email: `${basePath}/forgot-password/send-email`,
	reset_password: `${basePath}/reset-password`,
	workspaces: `${basePath}/workspaces`
}

export const TRANSLATE_AUTH = `user/auth`

export const TRANSLATE_ONBOARDING = `user/onboarding`
